// this is an autogenerated file from DesignSystem/AutomationTask/Stage/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AutomationTask_Stage($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id } }
    order_by: { order: asc }
  ) {
    id
    text: name
    order
    done
  }
}

`